import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";

import { ProductOutlined } from '@ant-design/icons';
import RegisteredAnimals from "./index";
import ViewRegisteredAnimal from "./view";
import EditRegisteredAnimal from "./edit";

const registeredAnimalRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Registered Animals",
		basePath: "registered-animals",
		mainComponent: <RegisteredAnimals />,
	    layout: "/console",
		icon: <ProductOutlined className="h-6 w-6" />,
	    subTitle:"Registered Animal",
	    viewComponent: <ViewRegisteredAnimal />,
	    createComponent: <EditRegisteredAnimal />,
	    editComponent: <EditRegisteredAnimal />,
	})
]

export default registeredAnimalRoutes;